import { render, staticRenderFns } from "./UpdateDoctypeModal.vue?vue&type=template&id=3b86d932&"
import script from "./UpdateDoctypeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateDoctypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports